<template>
    <button
        :class="[colorType === 'main' ? styles.btn_main : styles.btn_secondary]"
        :disabled="load"
        class="flex justify-center"
    >
        <slot/>
        <my-loader
            v-if="load"
            class="ml-2"
            sizeIcon="sm"
        ></my-loader>
        <BaseIcon
            v-else-if="icon"
            :icon="icon"
            class="ml-2"
            size="sm"
        />
    </button>
</template>

<script>
import MyLoader from '../../MyLoader'
import BaseIcon from '../BaseIcon'

export default {
  name: 'BaseButton',
  components: {
    BaseIcon,
    MyLoader
  },

  props: {
    icon: String,
    colorType: {
      type: String,
      default: 'main',
      validator (value) {
        return ['main', 'secondary'].includes(value)
      }
    },

    load: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      styles: window.myStyles
    }
  }
}
</script>

<style scoped>

</style>
